// Sesami graceful-failure fallback.
//
// Every <sesami-experience> the theme renders is paired with a hidden
// contact/phone fallback (see snippets/longeva-sesami-button.liquid).
// If the component has not rendered any visible content after a
// timeout -- because sesami-main.js failed to load, the shop/service
// id is not registered in Sesami, or any other initialisation error --
// the fallback is revealed so the customer is never left pressing an
// apparently dead button. This does not hide or swallow a genuine
// Sesami error message: if Sesami itself renders an error state inside
// the component, that already counts as "visible content" and the
// fallback stays hidden, since the customer can see Sesami's own
// message.
(function () {
  if (window.__longevaSesamiFallback) return;
  window.__longevaSesamiFallback = true;

  var TIMEOUT_MS = 6000;

  function hasRenderedContent(el) {
    var rect = el.getBoundingClientRect();
    if (rect.height > 4 && rect.width > 4) return true;
    if (el.shadowRoot && el.shadowRoot.childElementCount > 0) return true;
    return false;
  }

  function watch(el) {
    if (el.hasAttribute('data-longeva-sesami-watched')) return;
    el.setAttribute('data-longeva-sesami-watched', '1');
    var wrap = el.closest('.longeva-sesami-wrap');
    var fallback = wrap ? wrap.querySelector('[data-longeva-sesami-fallback]') : null;
    if (!fallback) return;
    setTimeout(function () {
      if (!hasRenderedContent(el)) {
        fallback.hidden = false;
      }
    }, TIMEOUT_MS);
  }

  function scan() {
    var nodes = document.querySelectorAll('sesami-experience[data-longeva-sesami-watch]');
    for (var i = 0; i < nodes.length; i++) watch(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // Sections can re-render (theme editor, AJAX cart, etc.) after first
  // paint; a light observer catches any sesami-experience added later.
  var observer = new MutationObserver(function () {
    scan();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
